import { Layout } from './layout';
import { Loading as SnapshotLoader } from './loading';

export function FinancialSnapshotsLoading() {
  return (
    <Layout>
      <SnapshotLoader />
    </Layout>
  );
}
